















import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import {
  WidgetMixin,
  IdMixin,
  EventMixin,
  FieldMixin,
  GroupMixin,
  InputMixin,
  Validator
} from "./mixins";
import AutoMixin from "@/mixins/auto";

@Component
export default class WTextArea extends Mixins(
  Mixins(WidgetMixin, IdMixin, FieldMixin, EventMixin),
  GroupMixin,
  AutoMixin,
  InputMixin
) {
  @Prop({ type: Number })
  rows?: number;

  created() {
    this.labelId = this.uniqueId("__W_INPUT_");
  }

  @Validator("required")
  requiredValidator(value: any) {
    return !!value;
  }

  changeHandler(value: string) {
    this.fieldValue = value;
  }
}
